import { get } from "lodash/fp";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Button,
  ButtonToolbar,
  Container,
  Content,
  FlexboxGrid,
  Form,
  Message,
  Panel,
  Schema,
} from "rsuite";
import { ResetPasswordServices } from "../../../core/services/ResetPasswordServices";
import { GlobalRoutes } from "../../../navigation/NavConstant";
import "./ResetPassword.css";

export function ResetPassword() {
  const formInitVal = {
    password: "",
    confirm_password: "",
  };
  const [formValue, setFormValue] = useState<any>(formInitVal);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [token, setToken] = useState("");
  let navigate = useNavigate();
  const { t } = useTranslation();

  function init() {
    let url = window.location.href.split("/");
    let token = url[url.length - 1];
    setToken(token);
    validateToken(token);
  }

  async function validateToken(token: any) {
    try {
      setError("");
      setMessage("");
      setLoading(true);
      let response: any = await ResetPasswordServices.validateToken({
        password_token: token,
      });
      setLoading(false);
    } catch (error: any) {
      setDisabled(true);
      setError(get("message", error));
      setLoading(false);
      console.log(error);
    }
  }

  async function resetPassword(valid: boolean, event: any) {
    try {
      setError("");
      setMessage("");
      setLoading(true);
      if (valid) {
        let response: any = await ResetPasswordServices.resetPassword({
          ...formValue,
          ...{ password_token: token },
        });
        setMessage(get("data.message", response));
        setFormValue(formInitVal);
        setToken("");
        setTimeout(function () {
          navigate("/login");
        }, 5000);
      }
      setLoading(false);
    } catch (error: any) {
      setError(get("message", error));
      setLoading(false);
      console.log(error);
    }
  }

  const model = Schema.Model({
    password: Schema.Types.StringType().isRequired(
      t("REQUIRED", {
        field: t("PASSWORD").toLowerCase(),
      })
    ),
    confirm_password: Schema.Types.StringType()
      .addRule((value, data) => {
        console.log(value, value !== data.password);
        if (value !== data.password) {
          return false;
        }
        return true;
      }, t("MATCH_PASSWORD").toLowerCase())
      .isRequired(
        t("REQUIRED", {
          field: t("CONFIRM_PASSWORD").toLowerCase(),
        })
      ),
  });

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="show-fake-browser forgot-password login">
      <Container className="container">
        <Content>
          <FlexboxGrid justify="center">
            <FlexboxGrid.Item colspan={6} className="login-bx">
              <Panel header={<h3 className="text-center">{t("CHANGE_PASSWORD")}</h3>}>
                <Form
                  fluid
                  model={model}
                  onSubmit={resetPassword}
                  onChange={(value: any) => setFormValue(value)}
                >
                  <Form.Group>
                    <Form.ControlLabel>{t("PASSWORD")}</Form.ControlLabel>
                    <Form.Control type="password" name="password" />
                    <span className="text-success">{message}</span>
                  </Form.Group>
                  <Form.Group>
                    <Form.ControlLabel>
                      {t("CONFIRM_PASSWORD")}
                    </Form.ControlLabel>
                    <Form.Control type="password" name="confirm_password" />
                  </Form.Group>
                  <Form.Group>
                    <ButtonToolbar className="space-between">
                      <Button
                        appearance="primary"
                        type="submit"
                        loading={loading}
                        disabled={isDisabled}
                      >
                        {t("SUBMIT")}
                      </Button>
                      <Button
                        appearance="link"
                        onClick={() => navigate(GlobalRoutes.LOGIN)}
                      >
                        {t("LOGIN")}
                      </Button>
                    </ButtonToolbar>
                    {error && <Message type="error">{error}</Message>}
                  </Form.Group>
                </Form>
              </Panel>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </Content>
      </Container>
    </div>
  );
}
